function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgMoon = function SvgMoon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.989 511.989",
    style: {
      enableBackground: "new 0 0 511.989 511.989"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#27536B"
    },
    cx: 255.994,
    cy: 255.994,
    r: 255.994
  }), React.createElement("path", {
    style: {
      fill: "#FCD57E"
    },
    d: "M391.37,292.817c-48.362,48.362-126.774,48.362-175.136,0s-48.362-126.774,0-175.136 c10.084-10.084,21.476-18.057,33.627-23.935c-39.798,1.061-79.279,16.774-109.653,47.147c-62.946,62.946-62.946,165.003,0,227.949 s165.003,62.946,227.949,0c30.374-30.374,46.086-69.854,47.147-109.653C409.427,271.341,401.454,282.733,391.37,292.817z"
  }), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "355.804,153.568 361.513,205.217 367.224,153.568 418.873,147.859 367.224,142.148  361.513,90.499 355.804,142.148 304.154,147.859  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "112.365,410.626 116.455,447.623 120.545,410.626 157.542,406.536 120.545,402.446  116.455,365.449 112.365,402.446 75.368,406.536  "
  }), React.createElement("rect", {
    x: 243.188,
    y: 248.208,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -106.4278 249.8396)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  }), React.createElement("rect", {
    x: 418.93,
    y: 193.377,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -16.1825 358.0481)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  }), React.createElement("rect", {
    x: 450.017,
    y: 284.419,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -71.4537 406.696)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  }), React.createElement("rect", {
    x: 76.067,
    y: 124.535,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -67.9259 95.4443)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  }), React.createElement("rect", {
    x: 346.322,
    y: 421.433,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -198.7088 373.5025)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  }), React.createElement("rect", {
    x: 117.587,
    y: 97.883,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -36.9191 116.9972)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moon.90acad72.svg";
export { ForwardRef as ReactComponent };